import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { Share2 } from 'lucide-react';
const SHARE_URL = encodeURIComponent('https://invisiblesperoInvencibles.com');
const SHARE_TEXT = encodeURIComponent('¿Sabías que tienes derechos sin importar tu estatus migratorio? Esta guía te explica cómo proteger a tu familia. ¡Compártela!');
const shareLinks = [{
  name: 'WhatsApp',
  href: `https://wa.me/?text=${SHARE_TEXT}%20${SHARE_URL}`,
  bg: 'bg-[#25D366]',
  hover: 'hover:bg-[#1ebe5d]',
  icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-212">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-213" />
      </svg>
}, {
  name: 'Facebook',
  href: `https://www.facebook.com/sharer/sharer.php?u=${SHARE_URL}`,
  bg: 'bg-[#1877F2]',
  hover: 'hover:bg-[#0d6efd]',
  icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-214">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-215" />
      </svg>
}, {
  name: 'Twitter / X',
  href: `https://twitter.com/intent/tweet?text=${SHARE_TEXT}&url=${SHARE_URL}`,
  bg: 'bg-[#0c1222]',
  hover: 'hover:bg-[#1a253a]',
  border: 'border border-white/20',
  icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-216">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-217" />
      </svg>
}];
export function ShareSection() {
  return <section className="py-20 bg-[#080e1a] border-t border-white/10" data-id="element-218">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-220">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#c0392b]/15 border border-[#c0392b]/30 mb-6" data-id="element-221">
            <Share2 className="w-6 h-6 text-[#c0392b]" data-id="element-222" />
          </div>

          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-223">
            ¿Conoces a alguien que necesite esta guía?
          </h2>
          <p className="text-lg md:text-xl text-[#c0392b] font-serif font-semibold mb-3" data-id="element-224">
            ¡Compártela y ayúdalo hoy!
          </p>
          <p className="text-gray-400 font-sans text-base max-w-xl mx-auto mb-10 leading-relaxed" data-id="element-225">
            Una familia preparada es una familia protegida. Compartir esta guía
            puede marcar la diferencia para alguien que lo necesita.
          </p>

          {/* Share Buttons */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.1
            }
          }
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-226">
            {shareLinks.map(link => <motion.a key={link.name} href={link.href} target="_blank" rel="noopener noreferrer" variants={{
            hidden: {
              opacity: 0,
              y: 10
            },
            visible: {
              opacity: 1,
              y: 0
            }
          }} whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} className={`inline-flex items-center justify-center gap-3 px-7 py-3.5 ${link.bg} ${link.hover} ${link.border ?? ''} text-white font-bold font-sans text-sm uppercase tracking-widest transition-colors duration-200 shadow-lg w-full sm:w-auto min-w-[200px]`} data-id="element-227">
                {link.icon}
                <span data-id="element-228">Compartir en {link.name}</span>
              </motion.a>)}
          </motion.div>

          {/* Secondary CTA */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="border-t border-white/10 pt-8" data-id="element-229">
            <p className="text-gray-500 font-sans text-sm italic" data-id="element-230">
              No compres, pero{' '}
              <span className="text-white font-semibold not-italic" data-id="element-231">
                comparte y ayuda a otra familia.
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}